import React from "react";
import { MetricCardProps } from "../type";
import { MetricCardFactory } from "./MetricCards/MetricCardFactory";

export const MetricCard: React.FC<MetricCardProps> = ({ data }) => {
  return <MetricCardFactory data={data} />;
};
